export default "__VITE_ASSET__77208120__"